module.exports = __webpack_public_path__ + "static/media/mobile_app.3b4f9202.svg";